import { useQuery } from "@tanstack/react-query";
import { fetchPaymentHistory } from "../api/fetchPaymentHistory";

export const usePaymentHistory = (companyId, enabled = true) => {
  const { data, error, isLoading, refetch } = useQuery({
    queryKey: ["paymentHistory", companyId],
    queryFn: () => fetchPaymentHistory(companyId),
    enabled: !!companyId && enabled,
  });

  return {
    data: data?.result || null,
    error,
    isLoading,
    refetch,
  };
};

